const registeredElements = new Set();

/** @type {MutationObserver} */
let rtlObserver;

/**
 * Observes document `dir` changes and updates `pageIsRTL` on hosts.
 * @param {typeof import('../core/CustomElement.js').default} Base
 */
export default function RTLObserverMixin(Base) {
  return Base
    .observe({
      /** Whether the page/document direction is RTL; kept in sync */
      pageIsRTL: {
        type: 'boolean',
        value: document.documentElement.dir === 'rtl',
      },
    })
    .on({
      connected() {
        if (!rtlObserver) {
          rtlObserver = new MutationObserver(() => {
            const isRTL = document.documentElement.dir === 'rtl';
            for (const el of registeredElements) {
              el.pageIsRTL = isRTL;
            }
          });
          rtlObserver.observe(document.documentElement, { attributeFilter: ['dir'] });
        }
        registeredElements.add(this);
      },
      disconnected() {
        registeredElements.delete(this);
      },
    });
}
